import { ComponentPropsWithoutRef, useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { FilterGroupContext } from 'components/filter/filters-next/FilterGroupContext';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { useUpdateFiltersByResource } from 'components/filter/useUpdateFiltersByResource';
import { twMerge } from 'tailwind-merge';

interface ClearFiltersButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'color'> {}

const ClearFiltersButton = (props: ClearFiltersButtonProps) => {
    const { children = 'Clear all', className = '', onClick, ...rest } = props;
    const { cacheKey, readOnly } = useContext(FilterProviderContext);
    const { groupId } = useContext(FilterGroupContext);
    const { currentGroup } = useFiltersByKey(cacheKey, groupId);
    const updateFilters = useUpdateFiltersByResource();

    if (!currentGroup || currentGroup.filters.length === 0 || readOnly) {
        return null;
    }

    return (
        <Button
            variant="none"
            color="primary"
            size="sm"
            className={twMerge('font-medium', className)}
            onClick={e => {
                updateFilters({
                    ...currentGroup,
                    filters: [],
                });
                onClick?.(e);
            }}
            {...rest}
        >
            {children}
        </Button>
    );
};

export { ClearFiltersButton };
